
/**
 * A player in the town
 */
export default class Player {
  public location?: UserLocation;

  private readonly _id: string;

  private readonly _userName: string;

  public ticTacToeStats: TicTacToeStats;

  public sprite?: Phaser.GameObjects.Sprite;

  public label?: Phaser.GameObjects.Text;
 
  constructor(id: string, userName: string, location: UserLocation, stats: TicTacToeStats) {
    this._id = id;
    this._userName = userName;
    this.location = location;
    this.ticTacToeStats = stats;
  }

  get userName(): string {
    return this._userName;
  }

  get id(): string {
    return this._id;
  }

  static fromServerPlayer(playerFromServer: ServerPlayer): Player {
    return new Player(playerFromServer._id, playerFromServer._userName, playerFromServer.location, playerFromServer.ticTacToeStats);
  }

  /**
   * Updates this player's TicTacToeStats based on the given GameResult
   * 
   * @param gameResult the result of a game that the player just finished
   */
   updateTicTacToeStats(gameResult: GameResult) : void {
    switch (gameResult) {
      case 'win':
        this.ticTacToeStats.wins += 1;
        break;
      case 'loss':
        this.ticTacToeStats.losses += 1;
        break;  
      case 'tie':
        this.ticTacToeStats.ties += 1;
        break;
      default: 
        throw new Error('Unknown game result');
    }
  }
}

export type ServerPlayer = { _id: string, _userName: string, location: UserLocation, ticTacToeStats: TicTacToeStats };

export type Direction = 'front'|'back'|'left'|'right';

export type UserLocation = {
  x: number,
  y: number,
  rotation: Direction,
  moving: boolean,
  conversationLabel?: string
  inLeaderboard? : boolean
  ticTacToeGameLabel?: string
};

export type TicTacToeStats = {
  wins: number;
  losses: number;
  ties: number;
};

export type GameResult = 'win' | 'loss' | 'tie';